export const SAVE_BUTTON_CLICK = 'LabelReviewApprovalForm/SAVE_BUTTON_CLICK';
